import { NavLink } from "react-router-dom";
import { AlertTriangle, CalendarCheck, ClipboardList, LayoutDashboard, Settings, Table2, Users, type LucideIcon } from "lucide-react";
import { cn } from "@/lib/cn";

interface NavItem {
  label: string;
  path: string;
  icon: LucideIcon;
  end?: boolean;
}

const NAV_ITEMS: NavItem[] = [
  { label: "Overview", path: "/", icon: LayoutDashboard, end: true },
  { label: "Scorecards", path: "/scorecards", icon: ClipboardList },
  { label: "Exception Center", path: "/exceptions", icon: AlertTriangle },
  { label: "Accountability", path: "/accountability", icon: Users },
  { label: "Weekly CEO Summary", path: "/weekly-summary", icon: CalendarCheck },
  { label: "Delegation Table", path: "/delegation", icon: Table2 },
  { label: "Admin", path: "/admin", icon: Settings },
];

/** Primary navigation on desktop. Hidden below the sm breakpoint — DashboardLayout renders an
 * equivalent horizontal tab strip for mobile instead, since a fixed-width sidebar doesn't fit
 * a phone-width viewport. */
export function Sidebar() {
  return (
    <aside className="hidden w-60 shrink-0 border-r border-border bg-card sm:block">
      <nav className="flex flex-col gap-1 p-3">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.end}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-accent hover:text-foreground",
                isActive && "bg-brand-muted text-brand hover:bg-brand-muted hover:text-brand",
              )
            }
          >
            <item.icon className="size-4 shrink-0" />
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
